import React from 'react';
import PropTypes from 'prop-types';

const PermissionName = ({
  nested,
  children,
}) => (
  <React.Fragment>
    <td display-if={nested} />
    <td colSpan={nested ? 1 : 2} className="c-table-permissions--permission-name">
      {children}
    </td>
  </React.Fragment>
);

PermissionName.propTypes = {
  nested: PropTypes.bool,
  children: PropTypes.node,
};

PermissionName.defaultProps = {
  nested: false,
  children: null,
};

export default PermissionName;
